import { Component, inject } from '@angular/core';
import { NoConnectionIllustrationComponent } from '../icons/illustrations/no-connection-illustration.component';
import { SiteStore } from 'src/app/store/site.store';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-offline',
  template: `
    <div
      class="offline-message-container"
      [ngClass]="{
        'translate-y-0': siteStore.isOffline(),
        'translate-y-36': !siteStore.isOffline(),
      }"
    >
      <div class="offline-message">
        <app-no-connection-illustration [size]="40" />
        <h1 class="text-lg">Se perdió la conexión a internet</h1>
      </div>
    </div>
  `,
  styleUrl: './offline.component.scss',
  imports: [NoConnectionIllustrationComponent,CommonModule]
})
export class OfflineComponent {
  siteStore = inject(SiteStore);
}
